/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResourceType } from './ResourceType';
import {
    ResourceTypeFromJSON,
    ResourceTypeFromJSONTyped,
    ResourceTypeToJSON,
    ResourceTypeToJSONTyped,
} from './ResourceType';
import type { AnonRequestFilter } from './AnonRequestFilter';
import {
    AnonRequestFilterFromJSON,
    AnonRequestFilterFromJSONTyped,
    AnonRequestFilterToJSON,
    AnonRequestFilterToJSONTyped,
} from './AnonRequestFilter';

/**
 * 
 * @export
 * @interface SimpleDataRequestResource
 */
export interface SimpleDataRequestResource {
    /**
     * 
     * @type {ResourceType}
     * @memberof SimpleDataRequestResource
     */
    resourceType: ResourceType;
    /**
     * 
     * @type {string}
     * @memberof SimpleDataRequestResource
     */
    resourceKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleDataRequestResource
     */
    portfolioKey: string;
    /**
     * 
     * @type {Array<AnonRequestFilter>}
     * @memberof SimpleDataRequestResource
     */
    filter?: Array<AnonRequestFilter>;
}



/**
 * Check if a given object implements the SimpleDataRequestResource interface.
 */
export function instanceOfSimpleDataRequestResource(value: object): value is SimpleDataRequestResource {
    if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
    if (!('portfolioKey' in value) || value['portfolioKey'] === undefined) return false;
    return true;
}

export function SimpleDataRequestResourceFromJSON(json: any): SimpleDataRequestResource {
    return SimpleDataRequestResourceFromJSONTyped(json, false);
}

export function SimpleDataRequestResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleDataRequestResource {
    if (json == null) {
        return json;
    }
    return {
        
        'resourceType': ResourceTypeFromJSON(json['resourceType']),
        'resourceKey': json['resourceKey'] == null ? undefined : json['resourceKey'],
        'portfolioKey': json['portfolioKey'],
        'filter': json['filter'] == null ? undefined : ((json['filter'] as Array<any>).map(AnonRequestFilterFromJSON)),
    };
}

export function SimpleDataRequestResourceToJSON(json: any): SimpleDataRequestResource {
    return SimpleDataRequestResourceToJSONTyped(json, false);
}

export function SimpleDataRequestResourceToJSONTyped(value?: SimpleDataRequestResource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resourceType': ResourceTypeToJSON(value['resourceType']),
        'resourceKey': value['resourceKey'],
        'portfolioKey': value['portfolioKey'],
        'filter': value['filter'] == null ? undefined : ((value['filter'] as Array<any>).map(AnonRequestFilterToJSON)),
    };
}

